'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import { Ban } from 'lucide-react'

type MessageEventData = {
  origin: string
  data: {
    type: string
  }
}

export default function DisableDraftModeButton() {
  const router = useRouter()

  useEffect(() => {
    const handleMessage = async (message: MessageEventData) => {
      if (message.data.type === 'strapiUpdate') {
        router.refresh()
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [router])

  const handleDisableDraftMode = async () => {
    const response = await fetch('/api/disable-preview')
    if (response.ok) {
      // Reload the page to reflect the updated state
      window.location.reload()
    } else {
      console.error('Failed to disable draft mode')
    }
  }

  return (
    <button
      onClick={handleDisableDraftMode}
      className="flex items-center justify-center hover:opacity-85"
    >
      <Ban className="mr-1 size-3" />
      Click to disable
    </button>
  )
}
